import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import { FormContext, FormItem, FormSubmitButton, MasterDetailForm, Widget, Button } from '@digital/ui'
import { ordemCompraIdState, reloadState, reloadVendorListState } from '../atoms'
import { useRecoilState, useRecoilValue } from 'recoil';
import { enviarEmailsConsolidacao } from '@app/api/sas/sasProposta';
import { TagComponentV2 } from '@app/components/Tag/indexv2';
import { Modal, Tooltip } from 'antd'
import { Visibility } from '@app/components';
import TipoOptions from "@app/types/core.types";
import { getAllUsuariosMRN, Usuario } from "@app/api/usuario";
import { uniqBy } from "lodash";
interface Props {

}

export const ButtonModalEnviarConsolidacaoparaArea = (props: Props) => {

    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);

    const [open, setOpen] = useState(false);
    const [emails, setEmails] = useState<TipoOptions[]>([])

    const onModalOpen = () => {
        setOpen(!open);
    }

    useEffect(() => {
        getAllUsuariosMRN()
            .then((response: Usuario[] | undefined) => {
                if (response) {
                    const emailsOpts = response.map((item: Usuario, index, self) => {
                        return {
                            text: item.email,
                            value: item.email
                        } as TipoOptions
                    });
                    setEmails([...uniqBy(emailsOpts, 'value').sort((a: any, b: any) => (a.value - b.value))])
                }
            })
    }, [])

    const onSubmit = (values: any) => {
        Modal.confirm({
            title: 'Confirmação Envio de Email',
            content:
                'Você deseja enviar este e-mail?',
            cancelText: 'Não',
            onCancel: () => {
                enviarEmailsConsolidacao({
                    ordemCompraId: ordemCompraId,
                    destinatarios: values.destinatarios,
                    enviarEmail: false
                })
                    .then((response: any) => {
                        if (response && response.valid) {
                            setReloadVendorList(!reloadVendorList);
                            onModalOpen()
                        }
                    });
            },
            okText: 'Sim',
            onOk: () => {
                enviarEmailsConsolidacao({
                    ordemCompraId: ordemCompraId,
                    destinatarios: values.destinatarios,
                    enviarEmail: true
                })
                    .then((response: any) => {
                        if (response && response.valid) {
                            setReloadVendorList(!reloadVendorList);
                            onModalOpen()
                        }
                    });
            },
        });
    }

    return (
        <>
            <Tooltip title={'Enviar Consolidação para a Área'}>
                <Button
                    onClick={onModalOpen}>
                    Enviar Consolidação para a Área
                </Button>
            </Tooltip>
            <Visibility visible={open} >

                <MasterDetailForm
                    key="formButtonModalEnviarConsolidacaoparaArea"
                    onSubmit={onSubmit}
                    validationSchema={Yup.object().shape({
                        destinatarios: Yup.array()
                            .min(1, 'É necessário adicionar no mínimo 1 destinatário')
                    })}
                >
                    <Modal
                        onCancel={() => setOpen(false)}
                        title='Enviar Consolidação para a Área'
                        visible={open}
                        footer={[
                            <Button
                                title='Fechar'
                                onClick={() => {
                                    setOpen(false);
                                }}
                                type="link"
                            />,
                            <FormSubmitButton noIcon type="primary" title='Enviar' />
                        ]}
                    >
                        <Widget >
                            <FormContext.Consumer>
                                {({ formProps }) =>
                                (
                                    <FormItem name='destinatarios'>
                                        <TagComponentV2
                                            buttonText="Novo destinatário"
                                            onChange={function (value: string[]): void {
                                                if (formProps) {
                                                    formProps.setFieldValue('destinatarios', value)
                                                }
                                            }}
                                            isValidateEmail
                                            hasLoadSelect={true}
                                            onLoadListSelect={async () =>
                                                emails
                                            }
                                        />
                                    </FormItem>
                                )}
                            </FormContext.Consumer>
                        </Widget>
                    </Modal>
                </MasterDetailForm>
            </Visibility>
        </>
    )
}